import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className={`font-heading text-xl font-bold ${isScrolled || !isHome ? "text-primary-500" : "text-background-50"}`}>
              韩漫之家
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome ? "text-foreground-700 hover:text-primary-500" : "text-background-50/90 hover:text-background-50"
              } ${location.pathname === "/" ? (isScrolled ? "text-primary-500" : "text-background-50") : ""}`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsCategoryOpen(!isCategoryOpen)}
                className={`text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer ${
                  isScrolled || !isHome ? "text-foreground-700 hover:text-primary-500" : "text-background-50/90 hover:text-background-50"
                }`}
              >
                分类浏览
                <i className={`ri-arrow-down-s-line transition-transform ${isCategoryOpen ? "rotate-180" : ""}`}></i>
              </button>
              {isCategoryOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-background-50 rounded-lg border border-background-200/70 py-2 shadow-sm min-w-[200px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      <i className={`${cat.icon} text-base`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled || !isHome ? "text-foreground-700 hover:text-primary-500" : "text-background-50/90 hover:text-background-50"
              }`}
            >
              关于我们
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
              isScrolled || !isHome
                ? "border border-primary-300 text-primary-600 hover:bg-primary-50"
                : "border border-background-50/40 text-background-50 hover:bg-background-50/10"
            }`}>
              登录
            </button>
            <button className="px-4 py-2 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer">
              开始阅读
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled || !isHome ? "text-foreground-700" : "text-background-50"
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link to="/" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors">
              首页
            </Link>
            <div className="px-3 py-2.5">
              <p className="text-sm font-medium text-foreground-500 mb-2">分类浏览</p>
              <div className="grid grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 px-2 py-2 text-sm text-foreground-600 hover:text-primary-500 hover:bg-background-100 rounded-lg transition-colors"
                  >
                    <i className={`${cat.icon} text-sm`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link to="/about" className="px-3 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-background-100 transition-colors">
              关于我们
            </Link>
            <div className="flex gap-3 mt-3 px-3">
              <button className="flex-1 px-4 py-2 rounded-full text-sm font-medium border border-primary-300 text-primary-600 hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer">
                登录
              </button>
              <button className="flex-1 px-4 py-2 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer">
                开始阅读
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}